import { RSKTEST } from '../types';
export default {
  type: RSKTEST,
  service: 'public',
  url: 'https://public-node.testnet.rsk.co',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
